export default "__VITE_ASSET__BfED$myy__"